import React from 'react';
import PropTypes from 'prop-types';

import { I18n } from 'Locales';
import { RowView } from 'Containers';
import { mockFunction } from 'Helpers';
import { MODAL_SIZES } from 'Constants';
import { Button, Modal } from 'Components';

const DynamicCheckInMessage = ({
  message = '',
  showCheckInDynamicMessageModal = false,
  onCloseModal = mockFunction
}) => (
  <Modal open={showCheckInDynamicMessageModal} size={MODAL_SIZES.SMALL} closeByBackdropClick={false}>
    <Modal.Title>
      <div className="text-md font-bold">{I18n.t('general:checkInMessage')}</div>
    </Modal.Title>

    <Modal.Content contentPosition={'flex-start'}>
      <RowView justifyContent={'flex-start'}>{message}</RowView>
    </Modal.Content>

    <Modal.Actions>
      <Button.Primary className="line-height-normal" width={'100%'} onClick={onCloseModal}>
        {I18n.t('general:ok')}
      </Button.Primary>
    </Modal.Actions>
  </Modal>
);

DynamicCheckInMessage.propTypes = {
  message: PropTypes.string,
  showCheckInDynamicMessageModal: PropTypes.bool,
  onCloseModal: PropTypes.func
};

export default DynamicCheckInMessage;
